export const HOSTS_API_PATH = '/api/hosts';
export const HOSTS_PATH = '/new/hosts';
export const API_REQUEST_KEY = 'HOSTS';



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/routes/Hosts/constants.js